import { type Dispatch, type SetStateAction } from 'react'

import { useIsTransferState } from 'pages/Transfer/Transfer.context'
import {
  TransferBpayState,
  TransferContactState,
  TransferGeneralState,
  TransferZellerState,
} from 'pages/Transfer/Transfer.stateMachine'
import { TransferContactSubmitButton } from 'pages/Transfer/TransferFields/TransferSubmitButton/TransferContactSubmitButton'
import { TransferContinueButton } from 'pages/Transfer/TransferFields/TransferSubmitButton/TransferContinueButton'
import { TransferZellerSubmitButton } from 'pages/Transfer/TransferFields/TransferSubmitButton/TransferZellerSubmitButton'

import { TransferBpaySubmitButton } from './TransferBpaySubmitButton'

const ZellerStatesBeforeSending = [
  TransferZellerState.Summary,
  TransferZellerState.Sending,
]

const ContactTransferStatesBeforeSending = [
  TransferContactState.Summary,
  TransferContactState.DeOutFallbackSummary,
  TransferContactState.Sending,
  TransferContactState.DeOutFallbackSending,
]
const BpayTransferStatesBeforeOrDuringSending = [
  TransferBpayState.Summary,
  TransferBpayState.Sending,
]

interface TransferSubmitButtonProps {
  setContactValidationError: Dispatch<SetStateAction<string | undefined>>
}

export const TransferSubmitButton = ({
  setContactValidationError,
}: TransferSubmitButtonProps) => {
  const isZellerState = useIsTransferState(TransferGeneralState.ZellerTransfer)
  const isContactTransferState = useIsTransferState<TransferContactState>(
    TransferGeneralState.ContactTransfer
  )
  const isBpayTransferState = useIsTransferState<TransferBpayState>(
    TransferGeneralState.BpayTransfer
  )

  if (isZellerState(ZellerStatesBeforeSending)) {
    return <TransferZellerSubmitButton />
  }

  if (isContactTransferState(ContactTransferStatesBeforeSending)) {
    return <TransferContactSubmitButton />
  }

  if (isBpayTransferState(BpayTransferStatesBeforeOrDuringSending)) {
    return <TransferBpaySubmitButton />
  }

  return (
    <TransferContinueButton
      setContactValidationError={setContactValidationError}
    />
  )
}
